import {Form, useSearchParams} from '@remix-run/react'

import {type ButtonProps} from '#app/ui/button'
import {HiddenField} from '#app/ui/forms/hidden-field'
import {StatusButton} from '#app/ui/status-button'
import {z} from '#app/utils/validation'

import {useIsPending} from './misc'

export const MICROSOFT_PROVIDER_NAME = 'microsoft'
// to add another provider, set their name here and add it to the providerNames below

export const providerNames = [MICROSOFT_PROVIDER_NAME] as const
export const ProviderNameSchema = z.enum(providerNames)
export type ProviderName = z.infer<typeof ProviderNameSchema>

export const providerLabels: Record<ProviderName, string> = {
  [MICROSOFT_PROVIDER_NAME]: 'Microsoft',
} as const

export function ProviderConnectionForm({
  providerName,
  buttonProps,
}: {
  providerName: ProviderName
  buttonProps?: ButtonProps
}) {
  const formAction = `/auth/${providerName}`
  const isPending = useIsPending({formAction})
  const [searchParams] = useSearchParams()
  const redirectTo = searchParams.get('redirectTo')

  return (
    <Form
      className="inline-flex items-center justify-center gap-2"
      action={formAction}
      method="POST"
    >
      {redirectTo ? <HiddenField name="redirectTo" value={redirectTo} /> : null}
      <StatusButton
        type="submit"
        className="w-full"
        status={isPending ? 'pending' : 'idle'}
        {...buttonProps}
      />
    </Form>
  )
}
